import { Button, Stack, UserInfo } from '@collaborate-health/uikit'
import { memo } from 'react'
import { Paper } from '@mui/material'
import { useDispatch, useSelector } from '@tabeeb/store'
import { removeOwner } from '@tabeeb/modules/sessionsPage/actions'
import { getSelectedUser } from '@tabeeb/modules/sessionsPage/selectors/contentSharings'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'

interface SelectedUserProps {
  contentSharingType: ContentSharingModelType
}

const SelectedUser: React.FC<SelectedUserProps> = ({ contentSharingType }) => {
  const dispatch = useDispatch()
  const selectedUser = useSelector((state) => getSelectedUser(state, { contentSharingType }))

  if (!selectedUser) {
    return null
  }

  return (
    <Paper variant='outlined'>
      <Stack direction='row' alignItems='center' justifyContent='space-between' p={0.5}>
        <UserInfo item={selectedUser} />
        <Button size='small' color='primary' variant='outlined' onClick={() => dispatch(removeOwner())}>
          Remove
        </Button>
      </Stack>
    </Paper>
  )
}

export default memo(SelectedUser)

